// © 2025 Camp Promethean, LLC. All Rights Reserved.
// Central paths for global brand assets under public/brand/.

export interface BrandAssets {
  /** Icon mark for dark app chrome (sidebar, loading). */
  logoMark: string;
  /** Icon mark for light surfaces (marketing, auth). */
  logoMarkLight: string;
  /** Full wordmark + mark for dark backgrounds. */
  logoFullOnDark: string;
  /** Full wordmark + mark for light backgrounds. */
  logoFullOnLight: string;
  favicon: string;
  appleTouchIcon: string;
}

const CLASSIC_BRAND: BrandAssets = {
  logoMark: "/brand/classic/logo-mark.svg",
  logoMarkLight: "/brand/classic/logo-mark-on-light.svg",
  logoFullOnDark: "/brand/classic/logo-full-on-dark.svg",
  logoFullOnLight: "/brand/classic/logo-full-on-light.svg",
  favicon: "/brand/classic/logo-mark.svg",
  appleTouchIcon: "/icons/cpappiconbig.png",
};

const ATHENA_BRAND: BrandAssets = {
  logoMark: "/icons/athena-logo-mobile.svg",
  logoMarkLight: "/icons/athena-logo-mobile.svg",
  logoFullOnDark: "/icons/athena-logo.svg",
  logoFullOnLight: "/icons/athena-logo.svg",
  favicon: "/icons/athena-favicon.png",
  appleTouchIcon: "/icons/athena-webclip.png",
};

export function getBrandAssets(skin: "classic" | "athena" = "classic"): BrandAssets {
  return skin === "athena" ? ATHENA_BRAND : CLASSIC_BRAND;
}
